import { render, staticRenderFns } from "./LunchMenuManagement.vue?vue&type=template&id=016f23ce&scoped=true"
import script from "./LunchMenuManagement.vue?vue&type=script&lang=js"
export * from "./LunchMenuManagement.vue?vue&type=script&lang=js"
import style0 from "./LunchMenuManagement.vue?vue&type=style&index=0&id=016f23ce&prod&lang=scss&scoped=true"
import style1 from "./LunchMenuManagement.vue?vue&type=style&index=1&id=016f23ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f23ce",
  null
  
)

export default component.exports